import classNames from "shared/utils/classNames";

import "./index.css";

type Props = {
  handleLikeDislike?: (status: string) => void;
  likeStatusType: string;
  likeStatus: string;
  className?: string;
  showColored?: boolean;
};

function LikeButton(props: Props) {
  const {
    handleLikeDislike,
    likeStatusType,
    likeStatus,
    className = "",
    showColored = false,
  } = props;

  return (
    <button
      onClick={() => {
        handleLikeDislike &&
          handleLikeDislike(
            likeStatus === likeStatusType ? "none" : likeStatusType,
          );
      }}
      className={classNames(
        "likeButton",
        likeStatusType,
        likeStatus === likeStatusType && "active",
        showColored && "showColored",
        className,
      )}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentFill"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          // eslint-disable-next-line max-len
          d="M14 3H11V9.5H14C14.1326 9.5 14.2598 9.44732 14.3536 9.35355C14.4473 9.25979 14.5 9.13261 14.5 9V3.5C14.5 3.36739 14.4473 3.24021 14.3536 3.14645C14.2598 3.05268 14.1326 3 14 3V3Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          // eslint-disable-next-line max-len
          d="M11 9.5L8.5 14.5C7.96957 14.5 7.46086 14.2893 7.08579 13.9142C6.71071 13.5391 6.5 13.0304 6.5 12.5V11H2.63125C2.48946 11.0004 2.34923 10.9704 2.21999 10.912C2.09075 10.8537 1.97549 10.7684 1.88195 10.6618C1.78841 10.5553 1.71876 10.4299 1.67767 10.2942C1.63659 10.1585 1.62502 10.0156 1.64375 9.875L2.39375 3.875C2.42409 3.63414 2.54102 3.41254 2.72272 3.25154C2.90442 3.09054 3.13849 3.00113 3.38125 3H11"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

export default LikeButton;
